export default __webpack_public_path__ + "static/media/8.5337a0bb.jpg";